const SDK_VERSION = '7.24.0';

export { SDK_VERSION };
//# sourceMappingURL=version.js.map
